module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAABHNCSVQICAgIfAhkiAAAAOBJREFUKFNjZCATMKLrmzlzZgFQLB6IDaByF4D0hPT09IXIauEa58+fL/Dr16/9SBrQzbzAxsbmmJiY+AEkAdc4Y8aMC4yMjPoEXH4BaLMhXCPUef1omhqh/Hpk8X///iVmZmYuANuIwzasGoHKwbaCNQJt/I/Fibg0MgA1MmLV+P///4tAHMDExLQeW2DBNSI7lZAmkHxGRoYBzEZQ3MECpwHIDsAVLSiBgyeAULwOsw0lHkEJ4OfPnwdwxSVIEzs7uwNGAoAZPX369ASg5gKYAVA/TwDFHdYkRyDFYEgDAJxDbQ98rQI5AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/6.png
// module id = /rnr
// module chunks = 1